// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as LumiRoute from "lumi-rescript/lib/es6/src/LumiRoute.res.js";
import * as Spinner$Web from "lumi-web/lib/es6/src/Spinner.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Util$Dashboard from "./Util.res.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Map$LumiFacilityMap from "lumi-facility-map/lib/es6/src/Map.res.js";
import * as Types$LumiDocuments from "lumi-documents/lib/es6/src/Types.res.js";
import * as FacilityMap$Dashboard from "./FacilityMap.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as SensorState$LumiDocuments from "lumi-documents/lib/es6/src/SensorState.res.js";
import * as ObjectStyle$LumiFacilityMap from "lumi-facility-map/lib/es6/src/ObjectStyle.res.js";

function calcSensorStyles(sensorStyles, sensorStates) {
  return Map$LumiFacilityMap.SensorStyles.merge(sensorStyles, Map$LumiFacilityMap.SensorStyles.fromArray(sensorStates.map(sensorState => {
    let occupied = SensorState$LumiDocuments.occupied(sensorState);
    return [
      sensorState.sensorKey,
      ObjectStyle$LumiFacilityMap.make(undefined, undefined, undefined, undefined, [
        [
          "facility-map-spot-free",
          !occupied
        ],
        [
          "facility-map-spot-occupied",
          occupied
        ]
      ], undefined)
    ];
  })));
}

function calcStats(pred, sensorStates) {
  let match = Stdlib_Array.reduce(sensorStates.filter(pred).map(sensorState => sensorState.measurement), Types$LumiDocuments.SensorMeasurement.empty, Types$LumiDocuments.SensorMeasurement.add);
  let error = match.error;
  let occupied = match.occupied;
  let free = match.free;
  return {
    capacity: (free + occupied | 0) + error | 0,
    free: free,
    occupied: occupied + error | 0
  };
}

function isUpperPlace(sensorInfos, param) {
  return Stdlib_Option.getOr(Stdlib_Option.map(Belt_Map.get(sensorInfos, param.sensorKey), param => Util$Dashboard.isUpperPlace(param.placeClass)), false);
}

function CurrentOccupation$Footer$StatsRow(props) {
  let stats = props.stats;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("span", {
            children: props.icon,
            className: "panel-icon"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                entry: props.label
              }),
              JsxRuntime.jsx("span", {
                children: stats.capacity,
                className: "tag is-light is-text"
              })
            ],
            className: "field is-grouped is-flex-grow-1 is-justify-content-space-between"
          })
        ],
        className: "panel-block has-text-weight-bold"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx("progress", {
            className: "progress is-inline-block is-info",
            max: stats.capacity.toString(),
            value: stats.occupied.toString()
          }),
          className: "control"
        }),
        className: "panel-block"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("span", {
                    children: stats.occupied,
                    className: "tag is-occupied"
                  }),
                  JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                      entry: "Occupied"
                    }),
                    className: "tag"
                  })
                ],
                className: "tags has-addons"
              }),
              className: "control"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                      entry: "Free"
                    }),
                    className: "tag"
                  }),
                  JsxRuntime.jsx("span", {
                    children: stats.free,
                    className: "tag is-free"
                  })
                ],
                className: "tags has-addons"
              }),
              className: "control"
            })
          ],
          className: "field is-grouped is-flex-grow-1 is-justify-content-space-between"
        }),
        className: "panel-block"
      })
    ]
  });
}

let StatsRow = {
  make: CurrentOccupation$Footer$StatsRow
};

function CurrentOccupation$Footer(props) {
  let match = props.stats;
  let lowerStats = match[1];
  let upperStats = match[0];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      upperStats.capacity > 0 && lowerStats.capacity > 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(CurrentOccupation$Footer$StatsRow, {
              label: "UpperPlaces",
              icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "ellipsis"
              }),
              stats: upperStats
            }),
            JsxRuntime.jsx(CurrentOccupation$Footer$StatsRow, {
              label: "LowerPlaces",
              icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "minus"
              }),
              stats: lowerStats
            })
          ]
        }) : null,
      JsxRuntime.jsx(CurrentOccupation$Footer$StatsRow, {
        label: "AllPlaces",
        icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "vector-square"
        }),
        stats: match[2]
      })
    ]
  });
}

let Footer = {
  StatsRow: StatsRow,
  make: CurrentOccupation$Footer
};

function CurrentOccupation(props) {
  let facilityInfos = props.facilityInfos;
  let mapUrl = props.mapUrl;
  let map = props.map;
  let mbFacilityMapKey = Stdlib_Option.map(map, m => m.map);
  let selectedSensorKey = Stdlib_Option.flatMap(map, m => m.selection);
  let facilityMapUrl = (facilityMapKey, mbSelectedSensorKey) => mapUrl({
    map: facilityMapKey,
    transform: Stdlib_Option.getOr(Stdlib_Option.map(map, m => {
      if (m.map === facilityMapKey) {
        return m.transform;
      } else {
        return Transform$Linear.M23f.identity;
      }
    }), Transform$Linear.M23f.identity),
    selection: Stdlib_Option.getOr(mbSelectedSensorKey, selectedSensorKey)
  });
  let facilityMaps = FacilityMap$Dashboard.useFacilityMaps(mbFacilityMapKey, selectedSensorKey, facilityMapUrl, facilityInfos);
  let dispatch = facilityMaps.dispatch;
  let match = facilityMaps.state;
  let sensorStates = match.sensorStates;
  let parentSensorStyles = match.sensorStyles;
  let sensorInfos = match.sensorInfos;
  let facilityMap = match.facilityMap;
  let sensorStyles = React.useMemo(() => calcSensorStyles(parentSensorStyles, sensorStates), [
    parentSensorStyles,
    sensorStates
  ]);
  let stats = React.useMemo(() => {
    let upper = calcStats(extra => isUpperPlace(sensorInfos, extra), sensorStates);
    let lower = calcStats(extra => !isUpperPlace(sensorInfos, extra), sensorStates);
    let total = calcStats(param => true, sensorStates);
    return [
      upper,
      lower,
      total
    ];
  }, [
    sensorInfos,
    sensorStates
  ]);
  let onSelectSensor = React.useCallback(mbSensorKey => dispatch({
    TAG: "SelectSensor",
    _0: mbSensorKey
  }), []);
  let showLayer = layer => {
    switch (layer) {
      case "Camera" :
      case "Display" :
      case "Indicator" :
        return false;
      default:
        return true;
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(FacilityMap$Dashboard.Sidebar.make, {
        facilityMaps: facilityMaps,
        facilityInfos: facilityInfos,
        toApplication: props.toApplication,
        facilityMapUrl: fm => facilityMapUrl(fm, undefined),
        children: facilityMap !== undefined ? JsxRuntime.jsx(CurrentOccupation$Footer, {
            stats: stats
          }) : null
      }),
      JsxRuntime.jsx("div", {
        children: facilityMap !== undefined && map !== undefined ? JsxRuntime.jsx(Map$LumiFacilityMap.make, {
            facilityMap: facilityMap,
            mapTransform: map.transform,
            setMapTransform: f => LumiRoute.followUrl(mapUrl({
              map: map.map,
              transform: f(map.transform),
              selection: map.selection
            }), undefined),
            showLayer: showLayer,
            sensorStyles: Primitive_option.some(sensorStyles),
            panButton: "Main",
            onClickBackground: param => onSelectSensor(undefined),
            onClickParkingPlace: (_event, _svgId, mbSensorKey) => onSelectSensor(mbSensorKey)
          }) : JsxRuntime.jsx(Spinner$Web.make, {}),
        className: "column contents"
      })
    ]
  });
}

let make = CurrentOccupation;

export {
  calcSensorStyles,
  calcStats,
  isUpperPlace,
  Footer,
  make,
}
/* react Not a pure module */
